module.exports = "https://bin.bnbstatic.com/_next/static/images/step4-9e1e461c9cd88410c3f4cc4d797c7635.png";